module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step3-1-40c179e6e8925b4b678ac7d2f4677cb6.gif";